import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import firestore from "."; // Ensure Firestore is correctly initialized

export const getOrCreateConversationIssue = async (
  creatorId,
  participantId,
  classId,
  creatorRole
) => {
  try {
    const conversationsRef = collection(firestore, "conversations");

    const q = query(
      conversationsRef,
      where("creatorId", "in", [creatorId, participantId]),
      where("participantId", "in", [creatorId, participantId]),
      where("classId", "==", classId),
      where("creatorRole", "==", creatorRole)
    );

    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      return querySnapshot.docs[0].id;
    }

    const newConversationRef = await addDoc(conversationsRef, {
      creatorId,
      participantId,
      classId,
      bookingSlotId: classId,
      participants: [creatorId, participantId],
      status: "opened",
      creatorRole,
    });

    return newConversationRef.id;
  } catch (error) {
    console.error("[Firestore] getOrCreateConversationIssue error", error);
    return null;
  }
};
